import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from "classnames"
import { Draggable, Droppable } from "@hello-pangea/dnd"
import { ChevronRight, ChevronDown, Trash } from 'react-feather'
import { Collapse, Button, UncontrolledTooltip } from 'reactstrap'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LockIcon } from "@csrc/assets/icons"
//************************************//
import { trans, uuidv4 } from '@utils'
import { CustomFieldTypes } from "@csrc/assets/data/constants"
import { CanCall } from "@modules/user"
//************************************//
import DeleteModal from "./DeleteModal"
import { LogsModuleIcon } from "../../libs/fwork-frontend-framework/assets/icons"

const FieldsList = props => {
  const { customFieldsState, onDeleteUnusedUrl } = props
  const { customFields, setCustomFields } = customFieldsState
  const [openedSection, setOpenedSection] = useState("new")
  const [filterText, setFilterText] = useState('')
  const [deleteModal, setDeleteModal] = useState({ show: false, data: null, onDelete: null })
  //************************************//
  const getFilteredItems = () => {
    return _.filter(customFields.unusedCustomFieldsList, x => x.name.toLowerCase().indexOf(filterText) > -1)
  }
  //************************************//
  const onAddItemToEntity = (type) => {
    setCustomFields(prevState => {
      const newItem = {
        key: `new_${uuidv4()}`,
        is_used: true,
        name: ``,
        description: "",
        field_type: type,
        is_required: false,
        default_value: {
          value: ""
        },
        config: [],
        parent_id: "group1"
      }
      return {
        ...prevState,
        entityCustomFieldsList: [
          ...prevState.entityCustomFieldsList,
          newItem
        ],
        editItemModal: {
          isNew: true,
          data: newItem
        }
      }
    })
  }

  return (
    <div className={'p-1 d-flex flex-column'} style={{ backgroundColor: '#283046' }}>
      <div className={'d-flex justify-content-between align-items-center'}>
        <span className={'text-white'}>{trans('customFields.newFields')}</span>
        {
          openedSection === "new" ? (
            <div className={'p-25'}>
              <ChevronDown
                // className='text-white cursor-pointer'
                // onClick={() => setOpenCreateFieldCollapse(false)}
                // aria-controls="collapse-page"
                // aria-expanded={openCreateFieldCollapse}
                color={'white'}
                size={14}
              />
            </div>
          ) : (
            <Button
              color={'flat-secondary'}
              className={'rounded-circle p-25'}
              size={'sm'}
              onClick={() => setOpenedSection("new")}
            >
              <ChevronRight
                className='feather-chevron-right'
                // className='text-white cursor-pointer'
                // onClick={() => setOpenCreateFieldCollapse(true)}
                // aria-controls="collapse-page"
                // aria-expanded={openCreateFieldCollapse}
                color={'white'}
                size={14}
              />
            </Button>
          )
        }
      </div>
      <Collapse isOpen={openedSection === "new"}>
        <Droppable
          isDropDisabled={true}
          key={'new-custom-fields'}
          droppableId={`new-custom-fields`}
        >
          {(droppableProvided, droppableSnapshot) => {
            return (
              <div
                ref={droppableProvided.innerRef}
                className={'d-flex justify-content-between mt-1'}
                style={{ flexWrap: "wrap" }}
                {...droppableProvided.droppableProps}
              >
                {
                  _.map(_.filter(CustomFieldTypes, x => !x.disabled), (typeOption, index) => {
                    return (
                      <Draggable
                        key={typeOption?.type}
                        className={'flex-1'}
                        draggableId={`${typeOption?.type}`}
                        index={index}
                      >
                        {(draggableProvided, draggableSnapshot) => {
                          return (
                            <div
                              className={classnames('w-50 p-25')}
                              onClick={e => {
                                e.preventDefault()
                                e.stopPropagation()
                                onAddItemToEntity(typeOption?.type)
                              }}
                              ref={draggableProvided.innerRef}
                              {...draggableProvided.draggableProps}
                              {...draggableProvided.dragHandleProps}
                            >
                              {/*<div className={'w-50 p-25'} key={index}>*/}
                              <div
                                // onClick={() => onAddItemToEntity(typeOption.type)}
                                className={'bg-white text-left d-flex align-items-center px-50 py-25'}
                                style={{ borderRadius: 5 }}
                              >
                                {typeOption.icon}
                                <span className={'ml-50'}>
                                  {trans(_.get(typeOption, 'label'))}
                                </span>
                              </div>
                            </div>


                            // </div>
                          )
                        }}
                      </Draggable>
                    )
                  })
                }
                {droppableProvided.placeholder}
              </div>
            )
          }}
        </Droppable>
      </Collapse>

      <hr className={'w-100'} style={{ borderTopColor: '#b9b9b9' }} />

      {/*<InputContainer*/}
      {/*  type={'uncontrolled-text'}*/}
      {/*  defaultValue={''}*/}
      {/*  placeholder={'Type to search all fields'}*/}
      {/*  onChange={e => setFilterText(e.target.value)}*/}
      {/*/>*/}

      <div className={'d-flex justify-content-between align-items-center mb-1'}>
        <div className={'d-flex'}>
          <span className={'text-white'}>
            {trans('customFields.unusedFields')}
          </span>
          <span className={'bg-white text-black ml-50 rounded px-25'}>
            {
              _.size(getFilteredItems())
            }
          </span>
        </div>
        {
          openedSection === "used" ? (
            <div className={'p-25'}>
              <ChevronDown
                color={'white'}
                size={14}
              />
            </div>
          ) : (
            <Button
              color={'flat-secondary'}
              className={'rounded-circle p-25'}
              size={'sm'}
              onClick={() => setOpenedSection("used")}
            >
              <ChevronRight
                className='feather-chevron-right'
                color={'white'}
                size={14}
              />
            </Button>
          )
        }
      </div>
      <Collapse isOpen={openedSection === "used"}>
        <div className={'unused-fields-overflow'}>
          <Droppable
            isDropDisabled={true}
            key={'custom-fields-details'}
            droppableId={`custom-fields-details`}
          >
            {(droppableProvided, droppableSnapshot) => {
              return (
                <div
                  ref={droppableProvided.innerRef}
                  className={classnames(`columns-list`, { isDraggingActive: droppableSnapshot.isDraggingOver })}
                  {...droppableProvided.droppableProps}
                >
                  {_.map(getFilteredItems(), (columnItem, index) => {
                    return (
                      <Draggable
                        key={columnItem.key}
                        className={'flex-1'}
                        draggableId={`${columnItem?.key}`}
                        index={index}
                      >
                        {(draggableProvided, draggableSnapshot) => {
                          // if (draggableSnapshot.isDragging) {
                          // 	const ele = document.getElementsByClassName(`template-${draggableSnapshot.draggingOver}`)[0]
                          // 	if (ele) {
                          // 		ele.classList.add(`depth-${item.depth}`)
                          // 	}
                          // }
                          return (
                            <div
                              className={classnames('custom-field-item-row px-75 py-25 my-25 d-flex justify-content-between align-items-center')}
                              ref={draggableProvided.innerRef}
                              {...draggableProvided.draggableProps}
                              {...draggableProvided.dragHandleProps}
                            // style={getItemStyle(
                            //   draggableSnapshot.isDragging,
                            //   draggableProvided.draggableProps.style,
                            //   item
                            // )}
                            >
                              <div className={'d-flex align-items-center'}>
                                {
                                  // The backend can serve a field_type this build does not
                                  // know yet (e.g. "media"), and an unguarded lookup here
                                  // threw "Cannot read properties of undefined (reading
                                  // 'icon')" inside the Draggable, unmounting the whole page.
                                  CustomFieldTypes[columnItem.field_type]?.icon
                                }
                                {/*<User size={16} className={'mx-25'}/>*/}
                                <span className={'mx-25'}>{_.get(columnItem, 'name')}</span>
                              </div>
                              {
                                columnItem.is_locked ? (
                                  <>
                                    <Button
                                      id={`tooltip-lock`}
                                      size={'sm'}
                                      color={'flat-danger'}
                                      className={'btn-icon delete-unused-field'}
                                    >
                                      <FontAwesomeIcon icon={LockIcon} size={'sm'} />
                                    </Button>
                                    <UncontrolledTooltip
                                      placement='top'
                                      target={`tooltip-lock`}
                                    >
                                      {trans('customFields.preventDeletingField')}
                                    </UncontrolledTooltip>
                                  </>
                                ) : (
                                  <CanCall action={props.actionDeleteUnusedCustomFields} id='addRoleBtn'>
                                    <Button
                                      size={'sm'}
                                      color={'flat-danger'}
                                      disabled={columnItem.is_locked}
                                      className={'btn-icon delete-unused-field'}
                                      onClick={() => {
                                        setDeleteModal({
                                          show: true,
                                          onDelete: async () => {
                                            await props.onDeleteUnusedCustomFields(columnItem.id)
                                            setCustomFields(prevState => ({
                                              ...prevState,
                                              unusedCustomFieldsList: _.filter(prevState.unusedCustomFieldsList, x => x.key !== columnItem.key)
                                            }))
                                          },
                                          data: {
                                            name: columnItem.name
                                          }
                                        })
                                      }}
                                    >
                                      <Trash size={'12'} />
                                    </Button>
                                  </CanCall>
                                )
                              }
                            </div>
                          )
                        }}
                      </Draggable>
                    )
                  })}
                  {droppableProvided.placeholder}
                </div>
              )
            }}
          </Droppable>
        </div>
      </Collapse>
      {
        deleteModal.show && (
          <DeleteModal
            data={{
              title: trans('customFields.deleteFieldTitle', { name: deleteModal.data.name }),
              text: trans('customFields.deleteFieldText'),
              subText: trans('customFields.deleteFieldSubText'),
              confirmButtonText: trans('customFields.deleteButtonText')
            }}
            onClose={() => setDeleteModal({ show: false, data: null, onDelete: null })}
            onDelete={deleteModal.onDelete}
          />
        )
      }
    </div>
  )
}

FieldsList.propTypes = {}

export default FieldsList
